import { useEffect, useState } from 'react';

import { logInDev } from '@ocx/utils';

import { parseVroomPostMessage } from './vroom-post-message.utils';
import * as vroomStorage from './vroom.storage';

export const useVroomStorage = (params: { iframeUrlTemplate: string; membershipId: string }) => {
  const { iframeUrlTemplate, membershipId } = params;
  const [lastVisitedUrl, setLastVisitedUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Load the initial session data
  useEffect(() => {
    const exec = async () => {
      const url = await vroomStorage.getLastVisitedUrl({ membershipId });
      if (!url) return;

      const { origin: iframeUrlTemplateOrigin } = new URL(iframeUrlTemplate);
      const { origin: lastVisitedUrlOrigin } = new URL(url);
      if (iframeUrlTemplateOrigin !== lastVisitedUrlOrigin) return;

      setLastVisitedUrl(url);
    };
    exec()
      .catch(logInDev)
      .finally(() => setIsLoading(false));
  }, [iframeUrlTemplate, membershipId]);

  // Register the message listener
  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      const { origin } = new URL(iframeUrlTemplate);
      const message = parseVroomPostMessage(event.data);

      if (event.origin !== origin) {
        return;
      }

      if (message.type === 'user_navigated') {
        const {
          data: { url },
        } = message;
        await vroomStorage.setLastVisitedUrl({ membershipId, url });
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [iframeUrlTemplate, membershipId]);

  return { lastVisitedUrl, isLoading };
};
